import { createContext } from 'react';

const indicatorContext = createContext();

export default indicatorContext;
